import React, {useState} from 'react'
import './dropdown.css';

function Dropdown({ value, label, className, long, children, small}) {

    const [active,
        setActive] = useState(false);

    return (
        <div className={ `isRelative dropdownHolder ${small && 'small'} ${long && 'w-100'}  ${className}`}>
            { label && <p className={ `sectionText--small textIsGray mb-1`}>{label}</p>}
            <div
                className={`hasBorder hasRadius spaceBetween isClickable dropdown ${long && 'w-100'}`}
                onClick={() => setActive(!active)}>
                <p className="sectionText mb-0 textIsGray">{value}</p>

                {active
                    ? <i class="ri-arrow-drop-up-line"></i>
                    : <i class="ri-arrow-drop-down-line"></i>}
            </div>

            <div className={`options ${active && 'active'}`} onClick={() => setActive(false)}>
                    {children}
                </div>

        </div>
    )
}

export default Dropdown
